export default __webpack_public_path__ + "static/media/fashion1.bdc94059.jpg";